import {CloseIcon, FilterIcon, RefreshIcon, SearchIcon} from '../../icons'
import text from './text.json'
import './index.scss'
import DateInterval from '../../components/pages/dateInterval'
import {ImgButton} from '../../components/core/button'
import classNames from 'classnames'
import InputWithIcon from '../../components/core/inputWithIcon'

const renderSearchButton = (onChange, onOpenModal, filteredFieldsCount, onClearFilters, isDarkMode, searched, onSearch) => {
    return <div className='search-container'>
        <span className='logs-search-field'>
            <InputWithIcon placeholder={text.search_for_logs}
                icon={<SearchIcon />}
                type="text"
                value={searched}
                name="search"
                className="search-input"
                onIconClick={onSearch}
                onChange={(e) => onChange(e)}
                hasAdditionalText={text.advanced_search}/>
        </span>
        <div className={classNames('filters-field', {
            'has-filters': filteredFieldsCount > 0,
            dark: isDarkMode
        })}>
            <ImgButton className='filter-button' onClick={onOpenModal}>
                <FilterIcon/>
                {text.filters}
                {filteredFieldsCount > 0 && <span>{filteredFieldsCount}</span>}
            </ImgButton>
            <span className='clear-filters-icon' onClick={onClearFilters}><CloseIcon width={16} height={16}/></span>
        </div>
    </div>
}

const getRefreshButton = (isDarkMode) => {
    return <ImgButton className={classNames('refresh-button', {
        dark: isDarkMode
    })}>
        <RefreshIcon className="refresh-icon"/>
        {text.refresh}
    </ImgButton>
}

const PageHeader = ({
    isDarkMode,
    setIsFiltersModalActive,
    filteredFieldsCount,
    onClearFilters,
    onResetDate,
    callbackFn,
    setSearched,
    onSearch,
    searched
}) => {
    const handleChange = (e) => {
        setSearched(e.target.value)
    }

    const openFiltersModal = () => {
        setIsFiltersModalActive(true)
    }

    return <div className='logs-header'>
        <div className='logs-header-search'>
            {renderSearchButton(handleChange, openFiltersModal, filteredFieldsCount, onClearFilters, isDarkMode, searched, onSearch)}
        </div>
        <div className='logs-header-right'>
            <DateInterval
                resetFn={onResetDate}
                callbackFn={callbackFn}/>
            {getRefreshButton(isDarkMode)}
        </div>
    </div>
}

export default PageHeader
